// The ink-surface undo toast from §s06/§s07 ("Saved 'Client onsite — LA' ·
// 5 items tagged · Undo"). A thin wrapper around sonner's `toast.custom` so
// every caller gets the same look and the same batchId wiring for the undo
// call, rather than hand-rolling a toast per feature.
import { toast } from 'sonner';

export function UndoToast({
  message,
  batchId,
  onUndo,
}: {
  message: string;
  batchId: string;
  onUndo: (batchId: string) => void;
}) {
  return (
    <div
      className="flex items-center gap-3 rounded-lg bg-primary px-3.5 py-3 text-sm text-primary-foreground shadow-bar"
      data-testid="undo-toast"
      data-batch-id={batchId}
    >
      <span className="h-2 w-2 rounded-full bg-confidence-high" aria-hidden="true" />
      <span className="flex-1">{message}</span>
      <button type="button" onClick={() => onUndo(batchId)} className="font-semibold underline">
        Undo
      </button>
    </div>
  );
}

/** Fires the toast via sonner's imperative API; callers own when to invoke it. */
export function showUndoToast(props: { message: string; batchId: string; onUndo: (batchId: string) => void }) {
  return toast.custom(() => <UndoToast {...props} />);
}

export default UndoToast;
